<script>
  import Bio from "./Bio.svelte";

    
</script>


<div id="short-intro" class="section">
    <div class="container">
        <div class="row center">
            <p class="flow-text intro-text">Welcome to my online portfolio! I'm a self-taught <span class="strong">Visual Artist</span>, a freelance <span class="strong">Designer</span>, a <span class="strong">Full-Stack Developer</span> and <span class="strong">Data enthusiast.</span> Feel free to look around!</p>

            <Bio/>
        </div> 
    </div>
</div> 



<style> 
    #short-intro{
        background-color: #efebe97e;
    }

    @media screen and (min-width: 800px) {
        .intro-text { font-size: 1.35em; }
    }


</style>